<template>
  <BaseStyle v-if="trackingId" class="text-center content-base space-y-3">
    <div class="inline-block py-1 px-10 border-current border rounded-full whitespace-nowrap">
      ID：{{ trackingId }}
    </div>
  </BaseStyle>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { useTrackingId } from '@/hooks/use_tracking_id';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentTrackingId',
  components: { BaseStyle },
  setup() {
    const trackingId = useTrackingId();
    return {
      trackingId,
    };
  },
});
</script>
